import React, { Component } from 'react'
import { withTranslate } from 'react-redux-multilingual'
import { Grid, Paper } from '@material-ui/core/'
// import { Scrollbars } from 'react-custom-scrollbars'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import ComparisonTable from './Comparison/Table/ComparisonTable'
import LineChart from './Comparison/Chart/LineChart'
import BarChart from './Comparison/Chart/BarChart'
import KpiTable from './KPI/Table/KpiTable'
// import Typography from '@material-ui/core/Typography'
import _ from 'lodash'

class PerformanceComparisonContent extends Component {
  state = {
    year: ''
  }
  render() {
    const { lineChart, tableData, barChart, dataKpi, percentChange, filterControls } = this.props

    let year = []

    if (lineChart) {
      year = Object.values(lineChart[0]?.data).map(item => {
        return item.x
      })
    }

    let [lastYear] = year.slice(-1) // เอา array ตัวสุดท้ายออกมา

    let label = ''

    if (filterControls.appraisal_type_id.value?.label === 'APT01 - Corporate') {
      label = 'Organization'
    } else {
      label = 'Employee'
    }

    return (
      <Aux>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <b>Performance by Year</b>
                <Paper>
                  <div style={{ height: 300 }}>
                    {_.size(lineChart) > 0 ? <LineChart lineChart={lineChart} /> : null}
                  </div>
                </Paper>
                <br />
                <Paper>
                  <div>
                    {_.size(tableData) > 0 ? (
                      <ComparisonTable
                        tableData={tableData}
                        filterControls={filterControls}
                        fetchDashboardPerformanceComparisonChartBar={param => {
                          this.props.fetchDashboardPerformanceComparisonChartBar(param)
                        }}
                        getYear={year => {
                          this.setState({ year: year })
                        }}
                      />
                    ) : null}
                  </div>
                </Paper>
              </Grid>
              <Grid item xs={12} md={6}>
                <b>
                  Performance by {label} : {this.state.year || lastYear}
                </b>
                <Paper>
                  <div style={{ height: 466, borderRadius: 10 }}>
                    {this.props.barChart?.length > 0 ? (
                      <BarChart
                        barChart={barChart}
                        percentChange={percentChange}
                        filterControls={filterControls}
                        dataKpiLoading={this.props.dataKpiLoading}
                        fetchDashboardPerformanceComparisonDataKpi={param =>
                          this.props.fetchDashboardPerformanceComparisonDataKpi(param)
                        }
                      />
                    ) : null}
                  </div>
                </Paper>
              </Grid>
              <Grid item xs={12} md={12}>
                <div>
                  {this.props.dataKpi?.length > 0 ? (
                    <KpiTable dataKpi={dataKpi} title={barChart[0]?.name} />
                  ) : null}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Aux>
    )
  }
}

export default withTranslate(PerformanceComparisonContent)
